import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const scroll = {
    timer: null,

    init() {
        this.progress();
        this.parallax();
        document.addEventListener('lazyloaded', () => this.refresh());
    },

    progress() {
        const bar = document.createElement('div');

        bar.className = 'ex-progress';
        bar.setAttribute('aria-hidden', 'true');
        document.body.appendChild(bar);

        const setScale = gsap.quickSetter(bar, 'scaleX');

        ScrollTrigger.create({
            start: 0,
            end: 'max',
            onUpdate: (self) => setScale(self.progress),
        });
    },

    parallax() {
        document.querySelectorAll('.elementor-widget-image > .elementor-widget-container').forEach((box) => {
            const widget = box.parentElement;
            const column = widget.parentElement;

            if (box.offsetHeight < 240 || !column || column.children.length !== 1 || widget.closest('.swiper, .slick-slider, [data-elementor-type="popup"]')) {
                return;
            }

            gsap.fromTo(box, { y: 30 }, {
                y: -30,
                ease: 'none',
                scrollTrigger: { trigger: widget, start: 'top bottom', end: 'bottom top', scrub: 0.8 },
            });
        });
    },

    refresh() {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => ScrollTrigger.refresh(), 250);
    },
};

export default scroll;
